var _circle, _circle2, _g, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.605 19.547h4.336l-9.023 8.934c-3.268 3.234-8.566 3.234-11.836 0l-9.027-8.934h4.34l6.855 6.787a5.339 5.339 0 0 0 7.495 0l6.86-6.787ZM21.339 44.39H17l9.082-8.989c3.268-3.234 8.566-3.234 11.836 0L47 44.391h-4.336l-6.914-6.842a5.338 5.338 0 0 0-7.495 0L21.34 44.39Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVXrp);
export default __webpack_public_path__ + "static/media/vXrp.9857b5e4fed15e0e53d764ea0d240e3d.svg";
export { ForwardRef as ReactComponent };